import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Header from "../components/headerfooter/Header";
import MobileFooter from "../components/MobileFooter";
import Loader from "../components/Loader";
import axios from "axios";
import { IMAGE_URL, PROMPT_VIDEO_URL, REACT_APP_API_PORT } from "../Api";
import { FiChevronDown, FiChevronUp } from "react-icons/fi";
import { getDecryptedData } from "../config/crypto";
import { Helmet } from "react-helmet";
import CategoryNavbar from "../components/headerfooter/CategoryNavbarBundle.jsx";


const MyPromptBundle = () => {

  
  const { id } = useParams(); // categoryId
  const [data, setData] = useState([]);
  const [catdata, setCatData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [copiedId, setCopiedId] = useState(null);
  const [tags, setTags] = useState("");
  const [search, setSearch] = useState("");
  const [categoryData, setcategoryData] = useState([]);
  const [showFilters, setShowFilters] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [category, setcategory] = useState("");
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [availableTags, setAvailableTags] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const limit = 9;


const getCategoryData = async () => {
  try {
    const res = await axios.get(
      `${REACT_APP_API_PORT}user/homepage/activepromptcategory`
    );
    setcategoryData(res.data.data || []);
  } catch (err) {
    console.log(err);
  }
};

const htmlToPlainText = (html = "") => {
  const div = document.createElement("div");
  div.innerHTML = html;
  return div.textContent || div.innerText || "";
};



 const fetchPrompts = async (page = 1) => {
  try {
    setIsLoading(true);
    const token = getDecryptedData("token");

    const res = await axios.get(
      `${REACT_APP_API_PORT}user/prompts_bundle/get_category/${id}`,
      {
        params: {
          page,
          limit,
          search,
          tags,
        },
        headers: {
          "x-access-token": token,
        },
      }
    );

    if (res.data?.status) {
      setData(res.data.prompts || []);
      setCatData(res.data.catData || []);
      setTotalPages(res.data.pagination?.totalPages || 1);
      setTotalItems(res.data.pagination?.totalItems || 0);
      setAvailableTags(res.data.availableTags || []);
    }
  } catch (err) {
    console.error("Fetch prompts error", err);
  } finally {
    setIsLoading(false);
  }
};

    useEffect(() => {
      setCurrentPage(1);
      getCategoryData();
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, [id]);

        // Search / tag change
      useEffect(()=>{
    fetchPrompts(currentPage);
    },[currentPage,search,tags,id])

    // Pagination
    useEffect(() => {
      fetchPrompts(currentPage);
    }, [currentPage]);


  const stripHtml = (html) => {
    const div = document.createElement("div");
    div.innerHTML = html;
    return div.textContent || div.innerText || "";
  };

  return (
    <>
      <Helmet>
        <title>My Purchased Prompts</title>
      </Helmet>

      <Header />
      <Loader isLoading={isLoading} />

      <section className="bg-black min-h-screen pt-32 px-4">

                {/* SEARCH + FILTER BAR */}
        <div className="max-w-[80rem] mx-auto px-4 mt-4 mb-6">
          <div className="flex justify-between items-center mb-4">
            <h2 className="leading-tight">
            <span className="block text-sm md:text-base text-gray-400 font-medium">
              Prompts Bundle Library
            </span>
            <span
            className="
              block
              text-[18px] md:text-[26px]
              font-bold
              tracking-wide
              bg-gradient-to-r from-orange-400 via-pink-500 to-purple-500
              bg-clip-text text-transparent
            "
          >
            {catdata?.category_name}
          </span>

          </h2>

            <button
              onClick={() => setShowFilters((prev) => !prev)} 
              className="
                  flex items-center gap-2
                  px-4 py-2 rounded-lg
                  text-sm font-semibold
                  bg-white/10 hover:bg-white/20
                  transition text-white
              "
              >
              Filters
              {showFilters ? (
                  <FiChevronUp className="text-lg" />
              ) : (
                  <FiChevronDown className="text-lg" />
              )}
              </button>
          </div>

          {showFilters && (
            <div className="rounded-2xl bg-black/95 p-4 sm:p-6
                            border border-white/20 mb-6">
              {/* SEARCH INPUT */}
              <input
                type="text"
                placeholder="Search prompts..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                className="w-full px-4 py-3 mb-4 rounded-full
                          bg-white/10 text-white placeholder-gray-400
                          border border-white/20 focus:outline-none"
              />


               <CategoryNavbar
                  categoryData={categoryData}
                  selectedCategory={selectedCategory}
                  setSelectedCategory={setSelectedCategory}
                  category={category}
                  setcategory={setcategory}
                  totalItems={totalItems}
                  tags={tags}
                  settags={setTags}
                  availableTags={availableTags}
              />
            </div>
          )}
        </div>


          {(data && data?.length > 0) && (
          <div className="max-w-[80rem] mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
            {data.map((item) => (
              <div
                key={item._id}
                className="
                  relative group overflow-hidden rounded-2xl
                  border border-white/30
                  shadow-lg
                  h-[420px]
                "
              >
                {/* IMAGE / VIDEO */}
                {item.prompt_type === "Image Prompt" && (
                
                  <img
                  src={item.image ? IMAGE_URL + item.image : "/just-launch-default.png"}
                  alt={item.title}
                  loading="lazy"
                  decoding="async"
                  fetchpriority="low"
                  onError={(e) => (e.currentTarget.src = "/just-launch-default.png")}
                  className="
                    absolute inset-0 w-full h-full object-cover
                    transition-all duration-500
                    blur-sm
                    [&.loaded]:blur-0
                  "
                  onLoad={(e) => e.currentTarget.classList.add("loaded")}
                />

                )}

                {item.prompt_type === "Video Prompt" && item.video && (
                
                  <video
                  src={PROMPT_VIDEO_URL + item.video}
                  preload="metadata"
                  muted
                  loop
                  playsInline
                  className="absolute inset-0 w-full h-full object-cover"
                />

                )}

                {/* OVERLAY */}
                <div className="absolute inset-x-0 bottom-0 h-[55%] bg-gradient-to-t from-black/70 via-black/40 to-transparent"></div>

                {/* TITLE */}
                <div className="absolute top-4 left-4 z-10">
                <span className="bg-black/60 px-3 py-1 rounded-full text-xs text-white font-semibold">
                  {item.title.length > 30
                    ? item.title.slice(0, 30) + "…"
                    : item.title}
                </span>
              </div>


                {/* CONTENT */}
                <div className="absolute bottom-0 p-5 w-full z-10">
                  <p className="text-white/90 text-sm line-clamp-3 mb-4">
                {item.prompt_type === "Image Prompt" && item.image_prompt
                  ? stripHtml(item.image_prompt)
                  : item.prompt_type === "Video Prompt" && item.video_prompt
                  ? stripHtml(item.video_prompt)
                  : stripHtml(item.short_description)}
              </p>


                 <div className="flex justify-between items-center gap-3">
  
            {/* LEFT : COPY BUTTON */}
            <button
            onClick={() => {
              const prompts = [];

              if (item.image_prompt) {
                prompts.push(htmlToPlainText(item.image_prompt));
              }

              if (item.video_prompt) {
                prompts.push(htmlToPlainText(item.video_prompt));
              }

              navigator.clipboard.writeText(prompts.join("\n\n"));

              setCopiedId(item._id);
              setTimeout(() => setCopiedId(null), 1500);
            }}
            className={`px-4 py-2 rounded-lg text-xs font-semibold text-white
              ${
                copiedId === item._id
                  ? "bg-gradient-to-r from-orange-500 via-pink-500 to-purple-500"
                  : "bg-white/20 hover:bg-white/30"
              }`}
          >
            {copiedId === item._id ? "✔ Copied" : "Copy Prompt"}
          </button>


              {/* RIGHT : TAGS */}
              <div className="flex gap-2 flex-wrap">
                {Array.isArray(item.tags) && item.tags.length > 0 &&
                  item.tags.map((tag, idx) => (
                    <span
                      key={idx}
                      className="
                        px-3 py-1
                        rounded-full
                        text-[10px] font-semibold uppercase
                        text-white
                        bg-white/10
                        border border-white/30
                        backdrop-blur
                      "
                    >
                      {tag}
                    </span>
                  ))
                }
              </div>

            </div>

                </div>
              </div>
            ))}
          </div>
        )}

        {isLoading && (
        <div className="max-w-[80rem] mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
          {Array.from({ length: 6 }).map((_, i) => (
            <div
              key={i}
              className="h-[420px] rounded-2xl bg-white/10 animate-pulse"
            />
          ))}
        </div>
      )}

        {!isLoading && data?.length === 0 && (
                        <div className="flex items-center justify-center h-64 bg-gray-900 rounded-2xl shadow-md">
                            <div className="text-center">
                                <svg
                                    className="mx-auto mb-4 h-12 w-12 text-gray-400"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="M9.75 9.75h.008v.008H9.75V9.75zM14.25 9.75h.008v.008h-.008V9.75zM12 14.25c-1.5 0-2.25 1.5-2.25 1.5h4.5s-.75-1.5-2.25-1.5z"
                                    />
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                                    />
                                </svg>
                                <h3 className="text-lg font-semibold text-gray-100">Data Not Found</h3>
                                <p className="text-sm text-gray-400 mt-1">We couldn't find any matching results.</p>
                            </div>
                        </div>
                    )}

                    {totalPages > 1 && (
                    <div className="w-full flex justify-center items-center gap-4 mt-10 mb-5 pb-10 md:pb-0">

                        {/* PREV */}
                        <button
                        disabled={currentPage === 1}
                        onClick={() => setCurrentPage((p) => p - 1)}
                        className={`px-5 py-2 rounded-lg text-white transition
                            ${
                            currentPage === 1
                                ? "bg-white/20 text-black cursor-not-allowed"
                                : "bg-white/20 hover:bg-white/30"
                            }`}
                        >
                        ⬅ Prev
                        </button>

                        {/* PAGE INFO */}
                        <span className="text-gray-300 text-xs lg:text-sm">
                        Page {currentPage} of {totalPages}
                        </span>

                        {/* NEXT */}
                        <button
                        disabled={currentPage === totalPages}
                        onClick={() => setCurrentPage((p) => p + 1)}
                        className={`px-5 py-2 rounded-lg text-white transition
                            ${
                            currentPage === totalPages
                                ? "bg-black cursor-not-allowed"
                                : "bg-white/10 hover:bg-white/20"
                            }`}
                        >
                        Next ➡
                        </button>

                    </div>
                    )}

        
      </section>

      <MobileFooter />
    </>
  );
};

export default MyPromptBundle;
